import { Drawer } from '@mui/material';
import { ThemeProvider, useTheme } from '@mui/material/styles';
import AutomationCentre from '../../../../components/automationCentre';
import { useTranslation } from "react-i18next";

interface IMessageEditDrawerProps {
  open: boolean;
  onClose: () => void;
  id?: number;
  templetName: string | undefined;
}

const MessageEditDrawer = ({
  open,
  onClose,
  id,
  templetName,
}: IMessageEditDrawerProps) => {

    const {
      i18n: { language },
    } = useTranslation();
    const isRtl = language == "ar";
    const theme = useTheme();
    const ltrTheme = { ...theme, direction: 'ltr' as const };

  return (
    <ThemeProvider theme={ltrTheme}>
      <Drawer
        anchor={isRtl ? 'left' : 'right'}
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            width: { xs: '100%', sm: '420px', md: '480px' },
          },
        }}
      >
        <AutomationCentre
          onclose={onClose}
          id={id}
          templetName={templetName}
          inDrawer
        />
      </Drawer>
    </ThemeProvider>
  );
};

export default MessageEditDrawer;
